/**
 * FAC Main About Section
 * スクロールによる縦書きナビゲーション
 */

class FacMainAbout {
  constructor(container) {
    this.container = container;
    this.nav = this.container.querySelector('.fac-main-about__nav');
    this.navLinks = this.container.querySelectorAll('.fac-main-about__nav-link');
    this.blocks = this.container.querySelectorAll('.fac-main-about__block');

    this.init();
  }

  init() {
    // スクロールイベントでナビゲーションをハイライト
    this.initScrollSpy();

    // ナビゲーションリンクのクリックイベント
    this.initNavigation();

    // パララックスの初期化
    this.initParallax();

    // ヘッダー色反転の初期化
    this.initHeaderColorInversion();
  }

  initParallax() {
    // ParallaxUtilityが読み込まれているか確認
    if (typeof window.ParallaxUtility === 'undefined') {
      console.warn('ParallaxUtility is not loaded yet');
      return;
    }

    this.parallax = new window.ParallaxUtility();
  }

  initScrollSpy() {
    const options = {
      root: null,
      rootMargin: '-50% 0px -50% 0px',
      threshold: 0,
    };

    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          const id = entry.target.id;
          this.setActiveNavLink(id);
        }
      });
    }, options);

    this.blocks.forEach((block) => {
      observer.observe(block);
    });
  }

  setActiveNavLink(targetId) {
    this.navLinks.forEach((link) => {
      const href = link.getAttribute('href');
      if (href === `#${targetId}`) {
        link.classList.add('is-active');
      } else {
        link.classList.remove('is-active');
      }
    });
  }

  initNavigation() {
    this.navLinks.forEach((link) => {
      link.addEventListener('click', (e) => {
        e.preventDefault();
        const targetId = link.getAttribute('href').substring(1);
        const targetBlock = document.getElementById(targetId);

        if (targetBlock) {
          // getBoundingClientRect()を使用してビューポートからの正確な位置を取得
          const rect = targetBlock.getBoundingClientRect();
          const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

          // data属性からオフセット値を取得（デフォルト値: PC=150, SP=60）
          const offsetPc = parseInt(targetBlock.dataset.offsetPc) || 150;
          const offsetSp = parseInt(targetBlock.dataset.offsetSp) || 60;
          const offset = window.innerWidth < 768 ? offsetSp : offsetPc;
          const offsetTop = rect.top + scrollTop - offset;

          window.scrollTo({
            top: offsetTop,
            behavior: 'smooth',
          });
        }
      });
    });
  }

  initHeaderColorInversion() {
    this.invertTargets = document.querySelectorAll('.invert-about-nav-color');
    this.invertClass = 'is-inverted';
    this.isInverted = false;

    if (!this.nav || this.invertTargets.length === 0) {
      console.info('Nav color inversion: required elements not found');
      return;
    }

    // スクロールイベントで重なりをチェック
    this.handleHeaderInversion = this.checkHeaderInversion.bind(this);
    window.addEventListener('scroll', this.handleHeaderInversion, { passive: true });
    window.addEventListener('resize', this.handleHeaderInversion, { passive: true });

    // 初回チェック
    this.checkHeaderInversion();
  }

  checkHeaderInversion() {
    if (!this.nav) return;

    const navRect = this.nav.getBoundingClientRect();
    let shouldInvert = false;

    // ナビゲーション要素が.invert-about-nav-color領域と完全に重なっているかチェック
    this.invertTargets.forEach((target) => {
      const targetRect = target.getBoundingClientRect();

      // 完全な重なり判定（ナビゲーションがターゲット領域の中に完全に含まれているか）
      const isCompletelyOverlapping =
        navRect.top >= targetRect.top &&
        navRect.bottom <= targetRect.bottom &&
        navRect.left >= targetRect.left &&
        navRect.right <= targetRect.right;

      if (isCompletelyOverlapping) {
        shouldInvert = true;
      }
    });

    // 状態が変わった場合のみクラスを切り替え
    if (shouldInvert !== this.isInverted) {
      this.toggleHeaderInversion(shouldInvert);
    }
  }

  toggleHeaderInversion(invert) {
    this.isInverted = invert;

    if (invert) {
      this.nav.classList.add(this.invertClass);
    } else {
      this.nav.classList.remove(this.invertClass);
    }
  }
}

// DOMが読み込まれたら初期化
document.addEventListener('DOMContentLoaded', () => {
  const aboutContainers = document.querySelectorAll('.fac-main-about');
  aboutContainers.forEach((container) => {
    new FacMainAbout(container);
  });
});
